webpackJsonp([25],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation']);
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[80]);


// WEBPACK FOOTER //
// bundles/catalog.bundle.js